module.exports = __webpack_public_path__ + "img/voting-down-voted.128a6ba5.svg";